import { defineMessages } from 'react-intl';

/** i18n messages for the YouTube playlists field. */
export const youtubePlaylistMessages = defineMessages({
  noManagePermissions: {
    id: 'socialExport.youtube.playlist.noManagePermissions',
    defaultMessage:
      'La conexión actual no tiene permisos para administrar playlists. Se debe reconectar para otorgar esos permisos.',
  },
});
